module.exports = __webpack_public_path__ + "5d71e09264616a47b8f9aaf9da608248.svg";